import { render, staticRenderFns } from "./LunchNotesWeekDayPerson.vue?vue&type=template&id=48f37492&"
import script from "./LunchNotesWeekDayPerson.vue?vue&type=script&lang=js&"
export * from "./LunchNotesWeekDayPerson.vue?vue&type=script&lang=js&"
import style0 from "./LunchNotesWeekDayPerson.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports